module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-02-58b016f82e138a3999b0a3c2c7950f77.webp";